'use strict';

/* eslint-disable no-undef */

/**
 * bind analytics for BV start review
 */
function bindReviewAnalytics() {
    var reviewContainer = document.querySelector('[data-bv-show="reviews"]');
    if (reviewContainer != null) {
        var reviewContainerShadow = reviewContainer.shadowRoot;
        var reviewButtons = reviewContainerShadow.querySelectorAll('.bv-reviews-product-rating-star');
        reviewButtons.forEach(function (reviewButton) {
            reviewButton.addEventListener('click', function () {
                $(document).trigger('bv:startreview', $(this).index());
            });
        });
    }
}

/**
 * Inside the custom preference, "Bazaarvoice Settings", the variable
 * bvHideForZeroReviews is a boolean value that determines whether a
 * product with zero reviews displays review functionality.
 * @param {Object} data - data being passed via the callback function
 */
function showReviewFunctionality(data) {
    var hideForZeroReviews = $('div[data-bv-hide-for-zero-reviews]').data('bv-hide-for-zero-reviews');
    if ((typeof data.TotalReviewCount !== 'undefined' && data.TotalReviewCount !== 0) || !hideForZeroReviews) {
        $('.bv-star-ratings, .bv-ratings, #product-reviews, #question-container, #bv-reviews-container').removeClass('d-none');
    }
}

$(document).ready(function () {
    document.addEventListener('readystatechange', function () {
        bindReviewAnalytics();
    });

    window.bvCallback = function (BV) {
        if (typeof BV !== 'undefined') {
            BV.configure('global', {
                events: {
                    bvRender: showReviewFunctionality,
                    submissionSubmitted: function (data) {
                        if (data.contentType === 'review' && data.SubmittedStep === 'mandatory') {
                            var rating;
                            var bvmodal = document.querySelector('[data-bv-show="inpage_submission"]');
                            if (bvmodal != null) {
                                var bvmodalShadowRoot = bvmodal.shadowRoot;
                                var ratingElement = bvmodalShadowRoot.querySelector('label[for="0_rating"][type="disclaimer"]');
                                if (ratingElement != null) {
                                    rating = ratingElement.innerText[0] || ratingElement.textContent[0];
                                }
                            }
                            $(document).trigger('bv:submitreview', rating);
                        }
                    }
                }
            });
        }
    };
});
